// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"fc239730","418":"2d8fb169","668":"e24cd2b8"}[chunkId] + ".js";
};